import { Controller } from "stimulus";
import 'jquery-countdown';

export default class extends Controller {
  static targets = ["dateRangeStart", "dateRangeEnd"];

  connect() {
    // Translate
    var days = "days"
    var hours = "h"
    var minutes = "min"
    var seconds = "sec"
    var btc_countdown = ""
    var ltc_countdown = ""

    fetch('/explain/bitcoin_stats').then(function(response){
      return response.json();
    }).then(function(data){
      var height2x = 840000
      var currentHeight = data
      var blocksToGo = height2x - currentHeight
      var avg_blk_time = 600
      var secondsFromNow = (height2x - currentHeight) * 1 * avg_blk_time
      var now = new Date()
      var forkDate = now.setSeconds(now.getSeconds() + secondsFromNow)
      $('.btc-half-countdown').countdown(forkDate, function(event){
        $(this).text(event.strftime('%-D days %-H h %M min %S sec'))
      });


      var btcHalfCurrentBlock = document.getElementById('btc-half-current-block')
      var btcHalfBlocksTogo = document.getElementById('btc-half-blocks-togo')
      var btcHalfEstimatedDatetime = document.getElementById('btc-half-estimated-datetime')

      if(btcHalfCurrentBlock != null){
        btcHalfCurrentBlock.innerHTML = (String(currentHeight).replace(/\B(?=(\d{3})+(?!\d))/g, ","))  
      }
      
      if(blocksToGo > 0 && btcHalfBlocksTogo != null && btcHalfEstimatedDatetime != null){
        btcHalfBlocksTogo.innerHTML = blocksToGo

        var estimatedDateTime = new Date(forkDate)
        btcHalfEstimatedDatetime.innerHTML = estimatedDateTime.getDate() + " " + estimatedDateTime.toLocaleString('default', { month: 'long' }) + " " + estimatedDateTime.getFullYear() + " " + estimatedDateTime.getHours() + ":" + estimatedDateTime.getMinutes() ;
      }
    })
  }
}
